<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de jornadas">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/relatorio-jornada/List'

export default {
    components: { List },
}
</script>